/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  ServerSideTableRequestDataRequest
} from '../../model/serverSideTableRequestDataRequest'
import type {
  ServerSideTableResponseAPIData
} from '../../model/serverSideTableResponseAPIData'
import type {
  TransactionCalculationData
} from '../../model/transactionCalculationData'
import type {
  TransactionCalculationDataList
} from '../../model/transactionCalculationDataList'
import type {
  TransactionCalculationListParams
} from '../../model/transactionCalculationListParams'
import type {
  TransactionCalculationPayloadCreateDataRequest
} from '../../model/transactionCalculationPayloadCreateDataRequest'
import type {
  TransactionCalculationViewData
} from '../../model/transactionCalculationViewData'
import type {
  TransactionCodeConfigBulkUpdateDataRequest
} from '../../model/transactionCodeConfigBulkUpdateDataRequest'
import type {
  TransactionCodeConfigData
} from '../../model/transactionCodeConfigData'
import type {
  TransactionCodeConfigDataList
} from '../../model/transactionCodeConfigDataList'
import type {
  TransactionCodeConfigDataRequest
} from '../../model/transactionCodeConfigDataRequest'
import type {
  TransactionCodeConfigListParams
} from '../../model/transactionCodeConfigListParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * List transaction calculations
 */
export const transactionCalculationList = (
    fundFamilyId: string,
    params?: TransactionCalculationListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TransactionCalculationDataList>(
      {url: `/fund-family/${fundFamilyId}/transactions/calculations/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getTransactionCalculationListQueryKey = (fundFamilyId: string,
    params?: TransactionCalculationListParams,) => {
    return [`/fund-family/${fundFamilyId}/transactions/calculations/`, ...(params ? [params]: [])] as const;
    }

    
export const getTransactionCalculationListQueryOptions = <TData = Awaited<ReturnType<typeof transactionCalculationList>>, TError = unknown>(fundFamilyId: string,
    params?: TransactionCalculationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCalculationListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCalculationList>>> = ({ signal }) => transactionCalculationList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCalculationListQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationList>>>
export type TransactionCalculationListQueryError = unknown

export const useTransactionCalculationList = <TData = Awaited<ReturnType<typeof transactionCalculationList>>, TError = unknown>(
 fundFamilyId: string,
    params?: TransactionCalculationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCalculationListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionCalculationListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionCalculationList>>, TError = unknown>(fundFamilyId: string,
    params?: TransactionCalculationListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCalculationListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCalculationList>>> = ({ signal }) => transactionCalculationList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCalculationListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationList>>>
export type TransactionCalculationListSuspenseQueryError = unknown

export const useTransactionCalculationListSuspense = <TData = Awaited<ReturnType<typeof transactionCalculationList>>, TError = unknown>(
 fundFamilyId: string,
    params?: TransactionCalculationListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCalculationListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionCalculationListLoader = (queryParamsOrFn?: (TransactionCalculationListParams | ((params: Params) => TransactionCalculationListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransactionCalculationListQueryKey(fundFamilyId, queryParams),
              queryFn: () => transactionCalculationList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a transaction calculation.
 */
export const transactionCalculationCreate = (
    fundFamilyId: string,
    transactionCalculationPayloadCreateDataRequest: TransactionCalculationPayloadCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TransactionCalculationData>(
      {url: `/fund-family/${fundFamilyId}/transactions/calculations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transactionCalculationPayloadCreateDataRequest
    },
      options);
    }
  


export const getTransactionCalculationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationCreate>>, TError,{fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationCreate>>, TError,{fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionCalculationCreate>>, {fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  transactionCalculationCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransactionCalculationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationCreate>>>
    export type TransactionCalculationCreateMutationBody = TransactionCalculationPayloadCreateDataRequest
    export type TransactionCalculationCreateMutationError = unknown

    export const useTransactionCalculationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationCreate>>, TError,{fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTransactionCalculationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List transaction calculations and fee basis.
 */
export const transactionCalculationAndFeeBasisList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/transactions/calculations-and-fees/`, method: 'GET', signal
    },
      options);
    }
  

export const getTransactionCalculationAndFeeBasisListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/transactions/calculations-and-fees/`] as const;
    }

    
export const getTransactionCalculationAndFeeBasisListQueryOptions = <TData = Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCalculationAndFeeBasisListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>> = ({ signal }) => transactionCalculationAndFeeBasisList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCalculationAndFeeBasisListQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>>
export type TransactionCalculationAndFeeBasisListQueryError = unknown

export const useTransactionCalculationAndFeeBasisList = <TData = Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCalculationAndFeeBasisListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionCalculationAndFeeBasisListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCalculationAndFeeBasisListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>> = ({ signal }) => transactionCalculationAndFeeBasisList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCalculationAndFeeBasisListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>>
export type TransactionCalculationAndFeeBasisListSuspenseQueryError = unknown

export const useTransactionCalculationAndFeeBasisListSuspense = <TData = Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationAndFeeBasisList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCalculationAndFeeBasisListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionCalculationAndFeeBasisListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransactionCalculationAndFeeBasisListQueryKey(fundFamilyId),
              queryFn: () => transactionCalculationAndFeeBasisList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get a transaction calculation.
 */
export const transactionCalculationRetrieve = (
    fundFamilyId: string,
    transactionCalculationId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TransactionCalculationViewData>(
      {url: `/fund-family/${fundFamilyId}/transactions/calculations/${transactionCalculationId}`, method: 'GET', signal
    },
      options);
    }
  

export const getTransactionCalculationRetrieveQueryKey = (fundFamilyId: string,
    transactionCalculationId: string,) => {
    return [`/fund-family/${fundFamilyId}/transactions/calculations/${transactionCalculationId}`] as const;
    }

    
export const getTransactionCalculationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError = unknown>(fundFamilyId: string,
    transactionCalculationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCalculationRetrieveQueryKey(fundFamilyId,transactionCalculationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCalculationRetrieve>>> = ({ signal }) => transactionCalculationRetrieve(fundFamilyId,transactionCalculationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && transactionCalculationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCalculationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationRetrieve>>>
export type TransactionCalculationRetrieveQueryError = unknown

export const useTransactionCalculationRetrieve = <TData = Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    transactionCalculationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCalculationRetrieveQueryOptions(fundFamilyId,transactionCalculationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionCalculationRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError = unknown>(fundFamilyId: string,
    transactionCalculationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCalculationRetrieveQueryKey(fundFamilyId,transactionCalculationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCalculationRetrieve>>> = ({ signal }) => transactionCalculationRetrieve(fundFamilyId,transactionCalculationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && transactionCalculationId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCalculationRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationRetrieve>>>
export type TransactionCalculationRetrieveSuspenseQueryError = unknown

export const useTransactionCalculationRetrieveSuspense = <TData = Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    transactionCalculationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCalculationRetrieveSuspenseQueryOptions(fundFamilyId,transactionCalculationId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionCalculationRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,transactionCalculationId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,transactionCalculationId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && transactionCalculationId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransactionCalculationRetrieveQueryKey(fundFamilyId,transactionCalculationId),
              queryFn: () => transactionCalculationRetrieve(fundFamilyId,transactionCalculationId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a transaction calculation.
 */
export const transactionCalculationUpdate = (
    fundFamilyId: string,
    transactionCalculationId: string,
    transactionCalculationPayloadCreateDataRequest: TransactionCalculationPayloadCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TransactionCalculationData>(
      {url: `/fund-family/${fundFamilyId}/transactions/calculations/${transactionCalculationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionCalculationPayloadCreateDataRequest
    },
      options);
    }
  


export const getTransactionCalculationUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationUpdate>>, TError,{fundFamilyId: string;transactionCalculationId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationUpdate>>, TError,{fundFamilyId: string;transactionCalculationId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionCalculationUpdate>>, {fundFamilyId: string;transactionCalculationId: string;data: TransactionCalculationPayloadCreateDataRequest}> = (props) => {
          const {fundFamilyId,transactionCalculationId,data} = props ?? {};

          return  transactionCalculationUpdate(fundFamilyId,transactionCalculationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransactionCalculationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationUpdate>>>
    export type TransactionCalculationUpdateMutationBody = TransactionCalculationPayloadCreateDataRequest
    export type TransactionCalculationUpdateMutationError = unknown

    export const useTransactionCalculationUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationUpdate>>, TError,{fundFamilyId: string;transactionCalculationId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTransactionCalculationUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a transaction calculation.
 */
export const transactionCalculationDelete = (
    fundFamilyId: string,
    transactionCalculationId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/transactions/calculations/${transactionCalculationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getTransactionCalculationDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationDelete>>, TError,{fundFamilyId: string;transactionCalculationId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationDelete>>, TError,{fundFamilyId: string;transactionCalculationId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionCalculationDelete>>, {fundFamilyId: string;transactionCalculationId: string}> = (props) => {
          const {fundFamilyId,transactionCalculationId} = props ?? {};

          return  transactionCalculationDelete(fundFamilyId,transactionCalculationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransactionCalculationDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof transactionCalculationDelete>>>
    
    export type TransactionCalculationDeleteMutationError = unknown

    export const useTransactionCalculationDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCalculationDelete>>, TError,{fundFamilyId: string;transactionCalculationId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTransactionCalculationDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List TransactionCodeConfigs. Only includes enabled TransactionCodeConfigs by default. To get all TransactionCodeConfigs, set include_inactive to True.
 */
export const transactionCodeConfigList = (
    fundFamilyId: string,
    params?: TransactionCodeConfigListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TransactionCodeConfigDataList>(
      {url: `/fund-family/${fundFamilyId}/transactions/configuration/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getTransactionCodeConfigListQueryKey = (fundFamilyId: string,
    params?: TransactionCodeConfigListParams,) => {
    return [`/fund-family/${fundFamilyId}/transactions/configuration/`, ...(params ? [params]: [])] as const;
    }

    
export const getTransactionCodeConfigListQueryOptions = <TData = Awaited<ReturnType<typeof transactionCodeConfigList>>, TError = unknown>(fundFamilyId: string,
    params?: TransactionCodeConfigListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCodeConfigList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCodeConfigListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCodeConfigList>>> = ({ signal }) => transactionCodeConfigList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionCodeConfigList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCodeConfigListQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCodeConfigList>>>
export type TransactionCodeConfigListQueryError = unknown

export const useTransactionCodeConfigList = <TData = Awaited<ReturnType<typeof transactionCodeConfigList>>, TError = unknown>(
 fundFamilyId: string,
    params?: TransactionCodeConfigListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionCodeConfigList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCodeConfigListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionCodeConfigListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionCodeConfigList>>, TError = unknown>(fundFamilyId: string,
    params?: TransactionCodeConfigListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCodeConfigList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionCodeConfigListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionCodeConfigList>>> = ({ signal }) => transactionCodeConfigList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCodeConfigList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionCodeConfigListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionCodeConfigList>>>
export type TransactionCodeConfigListSuspenseQueryError = unknown

export const useTransactionCodeConfigListSuspense = <TData = Awaited<ReturnType<typeof transactionCodeConfigList>>, TError = unknown>(
 fundFamilyId: string,
    params?: TransactionCodeConfigListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionCodeConfigList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionCodeConfigListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionCodeConfigListLoader = (queryParamsOrFn?: (TransactionCodeConfigListParams | ((params: Params) => TransactionCodeConfigListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransactionCodeConfigListQueryKey(fundFamilyId, queryParams),
              queryFn: () => transactionCodeConfigList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a TransactionCodeConfig
 */
export const transactionCodeConfigCreate = (
    fundFamilyId: string,
    transactionCodeConfigDataRequest: TransactionCodeConfigDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TransactionCodeConfigData>(
      {url: `/fund-family/${fundFamilyId}/transactions/configuration/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transactionCodeConfigDataRequest
    },
      options);
    }
  


export const getTransactionCodeConfigCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCodeConfigCreate>>, TError,{fundFamilyId: string;data: TransactionCodeConfigDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionCodeConfigCreate>>, TError,{fundFamilyId: string;data: TransactionCodeConfigDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionCodeConfigCreate>>, {fundFamilyId: string;data: TransactionCodeConfigDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  transactionCodeConfigCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransactionCodeConfigCreateMutationResult = NonNullable<Awaited<ReturnType<typeof transactionCodeConfigCreate>>>
    export type TransactionCodeConfigCreateMutationBody = TransactionCodeConfigDataRequest
    export type TransactionCodeConfigCreateMutationError = unknown

    export const useTransactionCodeConfigCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCodeConfigCreate>>, TError,{fundFamilyId: string;data: TransactionCodeConfigDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTransactionCodeConfigCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update a TransactionCodeConfig
 */
export const transactionCodeConfigUpdate = (
    fundFamilyId: string,
    transactionCodeConfigBulkUpdateDataRequest: TransactionCodeConfigBulkUpdateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TransactionCodeConfigDataList>(
      {url: `/fund-family/${fundFamilyId}/transactions/configuration/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionCodeConfigBulkUpdateDataRequest
    },
      options);
    }
  


export const getTransactionCodeConfigUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCodeConfigUpdate>>, TError,{fundFamilyId: string;data: TransactionCodeConfigBulkUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionCodeConfigUpdate>>, TError,{fundFamilyId: string;data: TransactionCodeConfigBulkUpdateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionCodeConfigUpdate>>, {fundFamilyId: string;data: TransactionCodeConfigBulkUpdateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  transactionCodeConfigUpdate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransactionCodeConfigUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof transactionCodeConfigUpdate>>>
    export type TransactionCodeConfigUpdateMutationBody = TransactionCodeConfigBulkUpdateDataRequest
    export type TransactionCodeConfigUpdateMutationError = unknown

    export const useTransactionCodeConfigUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionCodeConfigUpdate>>, TError,{fundFamilyId: string;data: TransactionCodeConfigBulkUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTransactionCodeConfigUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get transactions table columns
 */
export const transactionTableColumns = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/transactions/pivot`, method: 'GET', signal
    },
      options);
    }
  

export const getTransactionTableColumnsQueryKey = () => {
    return [`/transactions/pivot`] as const;
    }

    
export const getTransactionTableColumnsQueryOptions = <TData = Awaited<ReturnType<typeof transactionTableColumns>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionTableColumns>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionTableColumnsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionTableColumns>>> = ({ signal }) => transactionTableColumns(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionTableColumns>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionTableColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof transactionTableColumns>>>
export type TransactionTableColumnsQueryError = unknown

export const useTransactionTableColumns = <TData = Awaited<ReturnType<typeof transactionTableColumns>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionTableColumns>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionTableColumnsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionTableColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionTableColumns>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionTableColumns>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionTableColumnsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionTableColumns>>> = ({ signal }) => transactionTableColumns(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionTableColumns>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionTableColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionTableColumns>>>
export type TransactionTableColumnsSuspenseQueryError = unknown

export const useTransactionTableColumnsSuspense = <TData = Awaited<ReturnType<typeof transactionTableColumns>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionTableColumns>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionTableColumnsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionTableColumnsLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getTransactionTableColumnsQueryKey(),
          queryFn: () => transactionTableColumns(),
        }).then(() => null));
      /**
 * Get transactions table data
 */
export const transactionTableData = (
    serverSideTableRequestDataRequest: ServerSideTableRequestDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ServerSideTableResponseAPIData>(
      {url: `/transactions/pivot`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serverSideTableRequestDataRequest
    },
      options);
    }
  


export const getTransactionTableDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionTableData>>, TError,{data: ServerSideTableRequestDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionTableData>>, TError,{data: ServerSideTableRequestDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionTableData>>, {data: ServerSideTableRequestDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  transactionTableData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransactionTableDataMutationResult = NonNullable<Awaited<ReturnType<typeof transactionTableData>>>
    export type TransactionTableDataMutationBody = ServerSideTableRequestDataRequest
    export type TransactionTableDataMutationError = unknown

    export const useTransactionTableData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionTableData>>, TError,{data: ServerSideTableRequestDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTransactionTableDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    